var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.components),function(component){return _c('ComponentListItem',{attrs:{"component":component,"substance-lists":_vm.substanceLists}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }